import { makeStoreContext } from './makeStore';
import appReducer, { authInitialState } from './states';

const { StoreProvider, useStore, useDispatch } = makeStoreContext(
  appReducer,
  authInitialState,
);

export { StoreProvider, useStore, useDispatch };
